import { useQuery } from '@tanstack/react-query';

import { littleSpoonInventoryApi } from 'api/FBM/littleSpoonInventory';

export const littleSpoonInventoryQueryKeys = {
    all: ['littleSpoonInventory'],
    report: () => ['littleSpoonInventory', 'report'],
};

/**
 * React Query hook for the Little Spoon inventory and cover report.
 *
 * staleTime matches the backend's 15-minute cache TTL. A 403 surfaces as a typed
 * error and is never retried, so the page can tell "not authorized" apart from a
 * transient failure without waiting through the retry backoff.
 */
export const useLittleSpoonInventory = (options = {}) =>
    useQuery({
        queryKey: littleSpoonInventoryQueryKeys.report(),
        queryFn: async ({ signal }) => {
            const response = await littleSpoonInventoryApi.getInventory({ signal });

            if (response.statusCode === 403) {
                throw Object.assign(new Error('Forbidden'), { forbidden: true });
            }
            if (!response.status) {
                throw new Error(response.msg ?? 'Failed to load Little Spoon inventory');
            }

            return response.data?.report ?? null;
        },
        retry: (failureCount, error) => !error?.forbidden && failureCount < 2,
        staleTime: 15 * 60 * 1000,
        ...options,
    });
